import React, { useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AgendaLayout from "../components/AgendaLayout";
import { useNavigate } from "react-router-dom";


const CalendarMainPage = () => {
  const navigate = useNavigate();
  const userType = Number(localStorage.getItem("userType"));
  const allowedTypes = new Set([1, 2, 4, 5]);
  const allowed = allowedTypes.has(userType);

  useEffect(() => {
    if (!allowed) {
      navigate("/home");
    }
  }, [allowed, navigate]);

  if (!allowed) return null;

  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Agenda" />
        <AgendaLayout />

      </MasterLayout>
    </>
  );
};

export default CalendarMainPage;

